import type {ChartPaletteHue} from '../types/ChartPaletteHue';

/**
 * Categorical chart colors in their fixed order: blue, green, orange, purple.
 * A chart gives its first category blue, its second green, and so on. It never skips or
 * reorders a hue, so a category keeps its color when other categories are added.
 *
 * Known limit, accepted by design: green next to orange is hard to tell apart with red-green
 * color vision deficiency (OKLab distance 4.0 under protanopia), so the legend and the summary
 * cards must name every series. Light shades of different hues are too alike as well, so
 * shades only split one category. Orange has a 2.84:1 contrast on white, below the 3:1 that
 * Atlassian sets for chart colors.
 */
export const CHART_PALETTE = {
  blue: {
    base: 'palettes.blue.60.100',
    shades: ['palettes.blue.60.100', 'palettes.blue.50.100', 'palettes.blue.40.100'],
    summary: {background: 'palettes.blue.10.100', border: 'palettes.blue.50.100'},
  },
  green: {
    base: 'palettes.green.60.100',
    shades: ['palettes.green.70.100', 'palettes.green.60.100', 'palettes.green.50.100'],
    summary: {background: 'palettes.green.10.100', border: 'palettes.green.50.100'},
  },
  orange: {
    base: 'palettes.orange.70.100',
    shades: ['palettes.orange.80.100', 'palettes.orange.70.100', 'palettes.orange.60.100'],
    summary: {background: 'palettes.orange.10.100', border: 'palettes.orange.70.100'},
  },
  purple: {
    base: 'palettes.purple.60.100',
    shades: ['palettes.purple.60.100', 'palettes.purple.50.100', 'palettes.purple.40.100'],
    summary: {background: 'palettes.purple.10.100', border: 'palettes.purple.60.100'},
  },
} as const satisfies Record<string, ChartPaletteHue>;
